import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { ReactComponent as ErrorIcon } from "@/assets/images/error.svg";
import PixAndGoProvider from "@/context/PixAndGoContext";
import i18n from "@/translate/i18n";
import { getPixAndGoConfig } from "@/services/pixAndGoApi";

function UnavailableScreen() {
  return (
    <main className="flex flex-col items-center justify-center flex-1 px-6 py-10">
      <div className="w-full max-w-lg text-center flex flex-col items-center gap-6">
        <ErrorIcon className="w-24 h-24" />
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-bold text-pag-danger">
            {i18n.t("pixAndGo.unavailable.title")}
          </h1>
          <p className="text-base text-pag-on-background-muted leading-relaxed">
            {i18n.t("pixAndGo.unavailable.message")}
          </p>
        </div>
      </div>
    </main>
  );
}

function PixAndGoLayout({ children, merchantSlug }) {
  const [theme, setTheme] = useState(null);
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(!!merchantSlug);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    document.getElementById("root").classList.add("pix-and-go");
    return () => document.getElementById("root").classList.remove("pix-and-go");
  }, []);

  useEffect(() => {
    if (!merchantSlug) return;
    getPixAndGoConfig(merchantSlug)
      .then((res) => {
        const data = res?.data;
        if (data && typeof data === "object" && !Array.isArray(data)) {
          // Support new format { theme: {...}, tagline, ... } and legacy flat { "--pag-primary": "..." }
          const themeData = data.theme ?? (data["--pag-primary"] ? data : null);
          setTheme(themeData);
          setConfig(data);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message === "pix-and-go-not-enabled") {
          setUnavailable(true);
        }
      })
      .finally(() => setLoading(false));
  }, [merchantSlug]);

  return (
    <div style={theme} className="flex flex-col min-h-screen bg-pag-background">
      {loading && (
        <p className="m-auto text-pag-on-background-muted">
          {i18n.t("pixAndGo.unavailable.loading")}
        </p>
      )}
      {!loading && unavailable && <UnavailableScreen />}
      {!loading && !unavailable && (
        <PixAndGoProvider config={config}>{children}</PixAndGoProvider>
      )}
    </div>
  );
}

PixAndGoLayout.propTypes = {
  children: PropTypes.node.isRequired,
  merchantSlug: PropTypes.string,
};

PixAndGoLayout.defaultProps = {
  merchantSlug: undefined,
};

export default PixAndGoLayout;
